// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/scss/index.scss";
import httpRequest from "@/utils/httpRequest.js";
import store from "@/store/index";

import "./permission"; // permission control

Vue.use(ElementUI);
Vue.prototype.$http = httpRequest;
Vue.config.productionTip = false;
import Pagination from "@/components/Pagination";
import { download, downloadFile, handleBatchDownload } from "@/utils/comm";
//
import { getDictByCode } from "@/api/home/home";

// 文件上传组件
import ImgUpload from "@/components/ImgUpload";
import FileUpload from "@/components/FileUpload";
import moment from "moment";
Vue.prototype.$moment = moment;
// 全局组件挂载
Vue.component("Pagination", Pagination);
Vue.component("ImgUpload", ImgUpload);
Vue.component("FileUpload", FileUpload);

Vue.prototype.getDicts = getDictByCode;
Vue.prototype.download = download;
Vue.prototype.downloadFile = downloadFile;
Vue.prototype.downloadZip = handleBatchDownload;

//全局防止多次点击
import preventReClick from "@/utils/preventReClick";

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: false,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source"
  }
});
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js